export const NOT_STARTED = 'not-started';
export const DONE = 'done';